import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-[#05070C] px-6 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="label-eyebrow">Welcome back</div>
          <h1 className="font-display text-4xl md:text-5xl mt-4">Log in to your <span className="serif-italic text-[#2DD4BF]">2nd Innings</span></h1>
        </div>

        <div className="section-card">
          <form onSubmit={onSubmit} className="space-y-5">
            <div>
              <Label className="text-[#94A3B8]">Email</Label>
              <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                     className="mt-2 h-12 bg-[#0A1223] border-[#142542] text-[#E8ECF3]" />
            </div>
            <div>
              <Label className="text-[#94A3B8]">Password</Label>
              <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                     className="mt-2 h-12 bg-[#0A1223] border-[#142542] text-[#E8ECF3]" />
            </div>
            <button type="submit" disabled={busy} className="pill-solid w-full h-12 font-medium" data-testid="login-submit">
              {busy ? "Logging in…" : "Log in"}
            </button>
          </form>

          <div className="my-6 flex items-center gap-4">
            <div className="flex-1 h-px bg-[#142542]" />
            <span className="text-xs text-[#64748B]">OR</span>
            <div className="flex-1 h-px bg-[#142542]" />
          </div>

          <button onClick={googleLogin} className="pill-glow w-full h-12 font-medium" data-testid="google-login">
            Continue with Google
          </button>
        </div>

        <p className="mt-8 text-sm text-[#94A3B8] text-center">
          New here?{" "}
          <Link to="/register" className="text-[#2DD4BF] hover:underline" data-testid="link-register">
            Create an account
          </Link>
        </p>
      </div>
    </div>
  );
}
